module.exports = __webpack_public_path__ + "static/img/home2.e8382b35.png";